import { useState } from "react";
import AdMatchedRequestsTable from "../AdMatchedRequestsTable/AdMatchedRequestsTable";

import { HiOutlineMail } from "react-icons/hi";

import AdsMatchingPopUp from "./AdsMatchingPopUp/AdsMatchingPopUp";
import { InputText } from "primereact/inputtext";

export function AdsMatching({ adById, user, size }) {
  const [searchValue, setSearchValue] = useState("");
  const [requestsToSend, setRequestsToSend] = useState([]);
  const [canSearch, setCanSearch] = useState(false);
  const [popUp, setPopUp] = useState(false);

  const handleSearchChange = (ev) => {
    const value = ev.target.value;
    setSearchValue(value);
  };

  const handleKeyDown = (ev) => {
    if (ev.key === "Enter") {
      ev.preventDefault();
      setCanSearch(true);
    }
  };

  const handlePopUp = () => {
    setPopUp(!popUp);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
            marginBottom: 12,
          }}
        >
          <div style={{ fontSize: "12px", marginLeft: "2px" }}>
            {requestsToSend.length === 1
              ? `Has seleccionado ${requestsToSend.length} contacto`
              : `Has seleccionado ${requestsToSend.length} contactos`}
          </div>
          <div className="subHeader__subtitle_searchBarContainer">
            <i className="pi pi-search a" />
            <InputText
              id="search"
              value={searchValue}
              onChange={handleSearchChange}
              onKeyDown={handleKeyDown}
              placeholder="Buscar en esta lista un elemento"
              style={
                size > 425
                  ? { width: "30rem", marginRight: "1vw" }
                  : { width: "20rem" }
              }
            />
          </div>
          <span
            className={
              requestsToSend.length !== 0
                ? "buttonForm"
                : "buttonForm--disabled"
            }
            style={{
              marginRight: 8,
              display: "flex",
              alignItems: "center",
            }}
            onClick={() => {
              if (requestsToSend.length !== 0) handlePopUp();
            }}
          >
            {size < 495 ? (
              <HiOutlineMail
                style={{
                  marginRight: 7,
                  transform: "scale(125%)",
                  verticalAlign: "middle",
                }}
              />
            ) : (
              <>
                <HiOutlineMail
                  style={{
                    marginRight: 7,
                    transform: "scale(125%)",
                    verticalAlign: "middle",
                  }}
                />
                <span>Enviar email</span>
              </>
            )}
          </span>

          {popUp && (
            <AdsMatchingPopUp
              handlePopUp={handlePopUp}
              adById={adById}
              user={user}
              requestsToSend={requestsToSend}
            />
          )}
        </div>
      </div>

      <>
        <div className="card">
          <AdMatchedRequestsTable
            searchValue={searchValue}
            setCanSearch={setCanSearch}
            canSearch={canSearch}
            requestsToSend={requestsToSend}
            setRequestsToSend={setRequestsToSend}
          />
        </div>
      </>
    </>
  );
}
